// Sub-path: the states barrel as first import would break the core require cycle under jest.
import { NotificationProvider } from 'core/states/notification';

import { ISelectSpaCostPanelProps, SelectSpaCostPanel } from './SelectSpaCostPanel';

// Its own scope: SlidingPanel clears the ambient notification on dismiss, blanking the host's.
export const SelectSpaCostPanelWithProvider = (props: ISelectSpaCostPanelProps) => (
  <NotificationProvider>
    <SelectSpaCostPanel {...props} />
  </NotificationProvider>
);
